export default __webpack_public_path__ + "/src/assets/images/ic-modal-add-product-from-external-site.svg";